import ShowChartIcon from '@mui/icons-material/ShowChart';
import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { useRecordContext, useTranslate } from 'react-admin';
import { useNavigate } from 'react-router-dom';

export const PumpCurvesButton = (props: any) => {
  const record: any = useRecordContext(props);
  const navigate = useNavigate();
  const t = useTranslate();

  function openCurves() {
    navigate(`/pumps/${record.id}/curves`);
  }

  return (
    <Tooltip title={t('resources.pumps.actions.viewCurves')}>
      <IconButton onClick={() => openCurves()}>
        <ShowChartIcon />
      </IconButton>
    </Tooltip>
  );
};
